import alertify from 'alertifyjs';
import $ from 'jquery';

export default class Pop {
    static close(){
        $('.alertify').last().find('button.ajs-close').click()
    }
    static clean(title,
                    content,
                    onshow=$.noop(),
                    onclose=$.noop(),
                    className='',
                    full_screen = false,
                    button =false
    ) {
        // Extend existing 'alert' dialog
        if(!alertify.clean){
            alertify.dialog('clean',function(){
                return{
                    build:function(){ },
                    settings:{
                        'className':'cleanPop',
                        'message':'',
                        'full_screen':false,
                        'headerImg':false,
                        'button':false,
                    },
                    settingUpdated:function(key, oldValue, newValue){
                        const container = $(this.elements.commands.container)

                        switch(key){
                            case 'button':
                                if(newValue){
                                    $(this.elements.buttons.primary).replaceWith(newValue)
                                }
                                break;
                            case 'full_screen':
                                $(this.elements.root).toggleClass('full_screen',newValue)
                                break;
                            case 'className':
                                $(this.elements.root).addClass(`cleanPop ${newValue}`)
                                break;
                            case 'message':
                                this.setContent(newValue);
                                break;
                        }
                    },
                    hooks: {
                        onclose: function(){
                            setTimeout(function(){
                                alertify.clean().destroy();
                            }, 400);
                        }
                    }
                };
            },false,'alert');
        }
        return alertify.clean().set({
            focus: { element:0 },
            'startMaximized': full_screen,
            'movable': false,
            'full_screen': full_screen,
            'closableByDimmer':false,
            'title': title,
            'message': $(`<div class="pop_holder ${full_screen ? 'full_holder' : ''}">`).html(content).get(0),
            'onshow':onshow,
            'onclose':onclose,
            'className':className,
            'transition':'zoom',
            'button':button,

        })
    };
}